module.exports = __webpack_public_path__ + "fonts/b1335003d2016980469bb5ac3b749a01.txt";